module.exports = __webpack_public_path__ + "img/logo-smc.ab2bc39e.png";